import React from 'react';
import {
  HeaderWrapper,
  LeftSection,
  CenterSection,
  RightSection,
} from './CenterAlignedHeader.styles';

export type CenterAlignedHeaderProps = {
  logo: React.ReactNode;
  leftItems?: React.ReactNode[];
  rightItems?: React.ReactNode[];
};

export const CenterAlignedHeader: React.FC<CenterAlignedHeaderProps> = ({
  logo,
  leftItems = [],
  rightItems = [],
}) => {
  return (
    <HeaderWrapper>
      <LeftSection>
        {leftItems.map((item, index) => (
          <React.Fragment key={index}>{item}</React.Fragment>
        ))}
      </LeftSection>
      <CenterSection>{logo}</CenterSection>
      <RightSection>
        {rightItems.map((item, index) => (
          <React.Fragment key={index}>{item}</React.Fragment>
        ))}
      </RightSection>
    </HeaderWrapper>
  );
};
